import { paymentRoutes } from './apiRoutes';
import { axiosAuthInstance } from './auth';

export const stripePayment = (body) => axiosAuthInstance.post(paymentRoutes.stripePayment, body);
export const add_wallet = (body) => axiosAuthInstance.post(paymentRoutes.add_wallet, body);
